<template>
  <layout-admin-dashboard-view
    :show-toolbar="false"
    :back-route="{ name: 'admin' }">
    <template #title>
      <span>{{ tt("admin.conversations.title") }}</span>
    </template>
    <template #default>
      <div
        class="margin-auto-inline border-thin padding"
        style="max-width: 900px">
        <chat-view max-height="500px"></chat-view>
      </div>
    </template>
  </layout-admin-dashboard-view>
</template>

<script>
import ChatView from "@/client/views/Chat.vue";

export default {
  components: {
    ChatView,
  },
  layout: "adminDashboard",
  middleware: {
    requireSuperAdmin: {},
  },
  data: function () {
    return {};
  },
  computed: {
    userId() {
      return this.$store.getters["user/profile"].id;
    },
  },
  meta: "admin.conversations.browserTitle",
};
</script>
